export const user = state => state.user;
export const count = state => state.count;
export const userlist = state => state.userlist;


// WEBPACK FOOTER //
// ./src/store/getters.js